const loopbackUrl = (value) => {
  try {
    const url = new URL(value);
    return (
      ['http:', 'https:'].includes(url.protocol) &&
      ['localhost', '127.0.0.1', '[::1]'].includes(url.hostname) &&
      !url.username &&
      !url.password
    );
  } catch {
    return false;
  }
};

export function localDemoEnvironment({
  enabled = process.env.REACT_APP_LOCAL_DEMO_SESSION,
  webOrigin = window.location.origin,
  apiUrl = process.env.REACT_APP_API_URL,
} = {}) {
  return enabled === 'true' && loopbackUrl(webOrigin) && loopbackUrl(apiUrl);
}

export const DEMO_IVR_PATIENT = {
  firstName: 'Elena',
  lastName: 'Brooks',
  medicareId: '1AA0AA0AA00',
};

export const truthfulDemoIvrReceipt = (receipt) =>
  receipt?.demoOnly === true && receipt?.insuranceCheckPerformed === false;
